import React from "react";
import { Group, DebouncedDateInput, GroupItem } from "ra-friendsofbabba";
import useFormPermission from "../useFormPermission";

const DateGroupInput = (props) => {
  const hasFormPermission = useFormPermission();
  return (
    <Group {...props}>
      <GroupItem lg={4} md={5} sm={6}>
        <DebouncedDateInput
          source="work_start_at"
          disabled={!hasFormPermission("work_start_at")}
        />
      </GroupItem>

      <GroupItem lg={4} md={5} sm={6}>
        <DebouncedDateInput
          source="work_end_at"
          disabled={!hasFormPermission("work_end_at")}
        />
      </GroupItem>
    </Group>
  );
};
export default DateGroupInput;
